import RefreshSvg from 'components/_common/Icons/SVGIcons/RefreshSvg';
import { Preloader } from 'modules/admin/components/_common/Preloader';
import { lazy, Suspense, useCallback, useState } from 'react';

const SellYourFirearmsModal = lazy(() => import('../Modals/SellYourFirearmsModal'));

export default function SellYourFirearmSection() {
  const [showModal, setShowModal] = useState(false);

  // The modal itself is now role/login-aware (guest, customer, or FFL variants) - always
  // open it rather than skipping straight to a page for logged-in users.
  const handleSellClick = useCallback(() => {
    setShowModal(true);
  }, []);
  return (
    <>
      <div className="sell-card h-100" onClick={() => handleSellClick()}>
        <span className="sell-card__text">FIREARM TRADE-IN</span>
        <RefreshSvg className="sell-card__icon" />
        {/* <span className="sell-card__badge">{totalGunForSale}</span> */}
      </div>
      {showModal && (
        <Suspense fallback={<Preloader loading={true} />}>
          <SellYourFirearmsModal showModal={showModal} onClose={() => setShowModal(false)} />
        </Suspense>
      )}
    </>
  );
}
